import type { Namespace, NamespaceFile, NamespaceFileUrl } from './types.js';

export const feedback: Namespace = import.meta.glob<NamespaceFile>(
    '../locales/*/feedback.json' satisfies NamespaceFileUrl,
    { eager: true, import: 'default' },
);
